<template>
    <div>
        <div class="box__header">
            <span class="box__header--text">Terminy:</span>
        </div>
        <div v-for="occurrence, i in occurrences" class="occurrence">
            <el-button @click.stop="removeItemFromFormset(occurrences, occurrence)"
                       type="danger"
                       size="small"
                       title="Usuń termin"
                       class="occurrence__remove-button">
                <i class="fa fa-remove"></i>
            </el-button>
            <div class="inline-form-group">
                <el-form-item label="Data"
                              :error="errors && errors[i] && errors[i]['date']">
                    <el-date-picker type="date"
                                    format="yyyy/MM/dd"
                                    value-format="yyyy-MM-dd"
                                    placeholder="Data od"
                                    v-model="occurrence.date">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="Scena"
                              :error="errors && errors[i] && errors[i]['stage']">
                    <el-select filterable
                               clearable
                               v-model="occurrence.stage"
                               placeholder="Scena">
                        <el-option v-for="stage in $store.state.stages"
                                   :label="stage.name_pl"
                                   :key="stage.id"
                                   :value="stage.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="inline-form-group">
                <el-form-item label="Godzina rozpoczęcia"
                              :error="errors && errors[i] && errors[i]['hour_from']">
                    <el-time-picker v-model="occurrence.hour_from"
                                    value-format="HH:mm:ss"
                                    placeholder="Godzina rozpoczęcia">
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="Godzina zakończenia"
                              :error="errors && errors[i] && errors[i]['hour_to']">
                    <el-time-picker v-model="occurrence.hour_to"
                                    value-format="HH:mm:ss"
                                    placeholder="Godzina zakończenia">
                    </el-time-picker>
                    <el-alert v-show="occurrence.hour_from > occurrence.hour_to"
                              title="Podałeś godzinę następnego dnia."
                              type="warning"
                              show-icon>
                    </el-alert>
                </el-form-item>
            </div>
            <div class="inline-form-group" v-if="eventType === 'theater'">
                <el-form-item label="Liczba miejsc">
                    <el-input v-model="occurrence.number_of_seats"
                              placeholder="Liczba miejsc"/>
                </el-form-item>
            </div>
        </div>
        <el-button @click="addOccurrence" type="primary">Dodaj termin</el-button>
    </div>
</template>
<script>
    export default {
        props: ["occurrences", "errors"],
        computed: {
            eventType () {
                return this.$route.meta.eventType
            },
        },
        methods: {
            addOccurrence () {
                this.occurrences.push({})
            }
        }
    }
</script>
<style lang="scss" scoped>
    .occurrence {
        margin-bottom: 45px;
        position: relative;
        &__remove-button {
            position: absolute;
            cursor: pointer;
            z-index: 1;
            top: 0;
            right: -42px;
            border-radius: 50%;
            padding: 8px 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// EventOccurrences.vue?02723115